.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.infoText {
  color: var(--body-text-arrows-400);
  height: 40px;
  align-content: center;
}

gz-title + gz-form-field,
gz-title + gz-labeled-content,
gz-title + div {
  padding-top: 15px;
}

#action-field {
  position: relative;
  z-index: 0;
}

gz-labeled-content {
  &::part(content) {
    overflow: visible;
  }

  &::part(label) {
    --font-family: var(--font-family-secondary);
  }
}

#rules-scope-section {
  gz-radio-group {
    display: flex;
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: 410px;
  }

  .checkbox-width-320 {
    width: 320px;
  }

  .checkbox-width-220 {
    width: 220px;
  }
}

.action-title {
  color: var(--chart-300-icon-buttons);
}

#rule-settings-detect-by-content-section {

  #rule-settings-detect-by-content-categories-section {

    .container {
      display: flex;
      align-items: start;
      .firstColumn {
        width: 250px;

        #rule-settings-detect-by-content-custom-extensions-field {
          margin-left: 20px;
          width: 470px;
        }

        #rule-settings-detect-by-content-true-file-type-detection-field {
          width: 800px;
          gz-text {
            margin-top: 5px;
          }
        }
      }
    }
  }
}

#rules-actions-section {
  #rule-actions-primary-section {
    display: flex;
    align-items: center;

    gz-dropdown {
      --form-field-input-width: 480px;
    }

    gz-form-field + gz-form-field {
      margin-left: 25px;
    }
  }

  #rule-actions-secondary-section {
    margin-left: 20px;

    #rule-actions-append-header-name-field,
    #rule-actions-append-header-value-field {
      margin-left: 25px;

      --form-field-label-width: 195px;
      &::part(form-field-label) {
        font-size: var(--body-size-medium);
        line-height: 18px;
      }
    }
  }
}

#rule-scope-to-specific-field,
#rule-scope-from-specific-field {
  margin-top: calc(var(--spacer) * -4); // remove extra space
  margin-left: 50px;
}

gz-checkbox {
  width: auto;
}

gz-labeled-content {
  height: 18px;
}

.infoAction {
  margin-top: -20px;
}
